var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 40,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M-3.4 0h60.1v40h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M14.9 20.4c1-1.3 3.2 0 5-1-2 .2-3.3-1-5-.8 1.8-1.1 3.3.3 5.3-.2-2.6-.3-2.5-1.4-4.9-1.6 2.1-.9 3.1 1 5.2.5-2.4-.5-2.7-2-4.5-2.3 2.6-.4 2.4 1.2 5 1.4-2.6-1.1-2-2.1-4.1-3 2.4 0 2.3 1.7 4.7 2.1-2-1.3-1.8-2.6-3.6-3.5 2.1 0 2.3 2.1 4.4 2.8-1.9-1.5-1.4-2.8-3-4.1 2 .5 1.8 2.3 4 3.5-1.7-1.8-1-3-2.5-4.5 2 .6 1.3 2.4 3.3 4-1.1-2-.4-3.2-1.6-4.8 1.9 1 1 2.7 2.7 4.5-.8-2 0-3.2-.8-5 1.5 1.2.6 3 1.9 4.9-.5-2.5.6-3 .2-5.1 1.2 1.5-.1 3 .8 5.1 0-2.5 1.2-3 1-5 1.2 1.8-.7 3.3.1 5.2.2-2.3 1.7-3 1.8-4.7.9 1.6-1.1 2.8-.8 5 .6-2.4 2.3-2.7 2.5-4.3.5 1.9-1.7 2.8-1.6 5 .7-2.3 2.7-2.5 3.2-4.1.2 2-1.8 2.4-2.3 4.6 1-1.8 2.9-2 3.7-3.4 0 2-2.3 2.3-3 4.2 1.3-1.6 3-1.4 4.2-2.8-.1 1.8-2.4 1.7-3.7 3.6 1.5-1.3 3.6-.9 4.7-2 0 1.6-3 1.5-4.2 3 1.6-1 3.7-.5 4.9-1.3-.2 1.4-3.2 1-4.6 2.2 2-.6 3.5.3 5-.3-.7 1.3-3.4.5-4.9 1.4 1.7-.3 3.5.7 5.1.4-.5 1.2-3.5 0-5 .6 1.8 0 3 1.3 4.8 1.2-1 1-3.5-.4-5-.2 1.8.4 3.2 2 4.6 2-1.1 1-3.3-1.1-5-.9 1.8.5 3.3 2.6 4.3 2.6-1.1.8-3.3-1.7-4.8-1.6 1.8.8 2.7 2.9 3.9 3.2-1.5.5-3-2.3-4.6-2.4 1.9 1.2 2 3 3.4 3.8-1.5.3-2.6-2.8-4.2-3 1.6 1 1.8 3.5 2.8 4.2-1.5.1-2-3.2-3.7-3.6 1.4 1.1 1 3.5 2.1 4.6-1.6-.4-1.4-3.2-3-4.1 1.2 1.5.5 3.6 1.3 4.8-1.5-.6-.9-3.1-2.3-4.6.8 1.6 0 3.5.5 5-1.4-.6-.4-3.6-1.5-4.8.5 1.8-.4 3.4 0 5-1.5-1.7.2-3.4-1-5 .2 1.9-1.1 3.3-1 5-1-1.4.7-3.6-.2-5.3.2 2-1.6 3.6-1.5 4.9-.9-1.6 1-3.4.6-5.2-.2 1.8-2 2.8-2.3 4.5-.6-1.8 1.5-3.2 1.4-5-.7 1.7-2.4 2.4-3 4.1-.5-1.8 2-2.8 2.1-4.8-.8 1.9-2.9 2.3-3.5 3.6-.3-1.8 2.6-2.6 2.7-4.4-1 1.7-3.2 1.8-4 3.1 0-1.8 3-2 3.4-4-.9 1.5-3.4 1.3-4.4 2.4.1-1.6 3.5-1.7 4-3.3-1.3 1.2-3.5.7-4.8 1.7.7-1.7 3.8-1.4 4.5-2.6-1.4.8-3.8 0-5 .8 1-1.6 3.5-.7 4.9-1.7-2.3.3-3.6-.6-5.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M34.4 20A7.8 7.8 0 1 1 19 20a7.8 7.8 0 0 1 15.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M33.4 20A6.7 6.7 0 1 1 20 20a6.7 6.7 0 0 1 13.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M32.5 20A5.8 5.8 0 1 1 21 20a5.8 5.8 0 0 1 11.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M21.8 16.3c1.6 0 3.6 0 4.9 1.1q2.1-1.4 4.7-1.1l.9 1.6q-2-.3-4 .6a7 7 0 0 1 2.8 5.6l-.8.9c.3-2.3-.8-4.8-2.5-6 1.3 2 2.2 3.7 2 6.2l-.8.5c.3-2.2-.2-4.7-1.8-6.2 1 1.3 1.8 3.8 1.3 6.3l-1 .4a8 8 0 0 0-.8-6.2 8 8 0 0 0-.8 6.1l-.8-.2c-.5-2.4.2-5 1.2-6.4-1 .6-2 3.3-1.8 6l-.7-.3c-.4-2 .6-4.7 1.9-6.2a7 7 0 0 0-2.6 5.8l-.6-.5c-.3-2.2 1-4.5 2.5-5.8a8 8 0 0 0-4-.6z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/kg.dfef5f7fd67a093fa947ed675a8e4a56.svg";
export { ForwardRef as ReactComponent };